import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        VCard,
        {
          staticClass: "d-flex justify-space-between align-center py-2 pl-4",
          attrs: { flat: "", tile: "", ripple: { class: "primary--text" } },
          on: {
            click: _setup.handleSwitch,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _setup.handleSwitch.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c(VImg, {
                staticClass: "mr-4",
                attrs: {
                  src: "/static/_v1/pd/icons/ui-kit/club/club-percent.svg",
                  width: "24",
                  height: "24",
                  alt: _setup.t("Иконка Процент Клуба", _setup.options),
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column align-start" }, [
                _c("div", { staticClass: "text-body-1 text--text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _setup.t("Скидка на приём от 30%", _setup.options)
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "link-decoration-none primary--text",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _setup.openDialog.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_setup.t("Подробнее", _setup.options)) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(VSwitch, {
            staticClass: "pt-0 mt-0 pl-1",
            attrs: {
              value: _setup.filtersStore.unsavedFilters.isClubAppointment,
              "input-value":
                _setup.filtersStore.unsavedFilters.isClubAppointment,
              color: "primary",
              "hide-details": "",
              dense: "",
              inset: "",
            },
            on: { input: _setup.emitChanges },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.ClubModal, {
        attrs: {
          attach: ".vue-the-doctors-filters .v-application",
          value: _setup.isDialogOpened,
        },
        on: { input: _setup.closeDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }